import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import { ModalButtonResponseEnum } from '../../../enum/modal-button-response.enum';
import { BaseModalComponent } from '../../../models/base-modal.component.model';

@Component({
  selector: 'app-confirm-with-message-modal',
  templateUrl: './confirm-with-message-modal.component.html',
  styleUrls: ['./confirm-with-message-modal.component.scss']
})
export class ConfirmWithMessageModalComponent implements OnInit, BaseModalComponent {
  public title: string;
  public cancelText: string;
  public okText: string;
  public okClass: string;
  public message: string;
  public routerLink?: string;
  public action: Subject<ModalButtonResponseEnum>;
  public selectList: { value: any; label: any }[];
  public selectLabel: string;
  public isRequireSelect: boolean;
  public selected: string;

  placeholder = '';

  isRequiredConfirmMessage: boolean;
  showErrorMessage: boolean;
  showErrorSelect: boolean;
  confirmMessage: string;
  label: string;

  constructor(
    public bsModalRef: BsModalRef,
    private router: Router,
    private readonly translate: TranslateService
  ) {}

  ngOnInit() {
    this.action = new Subject();
    this.okText = this.okText || this.translate.instant('OK');
    this.okClass = this.okClass || 'btn btn-primary';
    this.cancelText = this.cancelText || this.translate.instant('Cancel');
  }

  confirm(): void {
    this.confirmMessage = this.confirmMessage?.trim();
    this.showErrorMessage = this.isRequiredConfirmMessage && !this.confirmMessage;
    this.showErrorSelect = this.isRequireSelect && !this.selected;

    if (this.showErrorMessage || this.showErrorSelect) {
      return;
    }
    if (!this.isRequiredConfirmMessage && !this.confirmMessage) {
      this.confirmMessage = null;
    }
    this.action.next(ModalButtonResponseEnum.OK);
    this.bsModalRef.hide();

    if (this.routerLink) {
      this.router.navigateByUrl(this.routerLink);
    }
  }

  decline(): void {
    this.action.next(ModalButtonResponseEnum.CANCEL);
    this.bsModalRef.hide();
  }
}
